<template>
    <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card color= "grey lighten-5">
            <v-flex xs12 sm12>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title >{{dialog_baslik}}</v-toolbar-title>
              </v-toolbar>
            </v-flex>
            <v-card-text>

<v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                <v-layout  wrap>
                       <div class="flex md12">

                    <v-text-field v-show="addgib" label="Hesap Kodu"  mask="AA"    v-model="hesap.Kod" :error-messages="errors.collect('gibseri')" v-validate="'required|max:2'"
                      data-vv-name="gibseri" required>
                    </v-text-field>

                    <v-text-field  label="Hesap Adı"    v-model="hesap.Adi"
                      required>
                    </v-text-field>


                   <v-radio-group v-model="hesap.Tipi" label="Hesap Tipi" column>
                      <v-radio label="D" color="orange darken-3" value="D"> </v-radio>
                      <v-radio label="M" color="orange darken-3" value="M"></v-radio>
                      <v-radio label="S" color="orange darken-3" value="S"></v-radio>
                    </v-radio-group>
                       </div>
                </v-layout>

</v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-show="m === true">
                <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
                <v-btn id="bsil" color="blue darken-1" flat @click="deletehesap()">Sİl</v-btn>
              </div>

              <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
                <div v-show="k === true">
                <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout row wrap>
        <v-toolbar  size="120px" dark color="info">
          <v-toolbar-title >Hesap Gurubu Tanımlama</v-toolbar-title>
          <v-spacer></v-spacer>
                     <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>

          <v-btn hidden="xs" flat @click="hesapekle()"> Hesap Gurubu Ekle
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </v-toolbar>
      </v-layout>

      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-data-table :headers="headers" :rows-per-page-items=[50,100]  :items="items" :loading="progress" :search="search3">
                    <v-progress-linear slot="progress"   indeterminate></v-progress-linear>

          <template slot="items" slot-scope="props">
            <tr @click="Getir(props.item.Kod)" item>
              <td class="text-xs-left">{{ props.item.Kod }}</td>
              <td class="text-xs-left">{{ props.item.Adi }}</td>
              <td class="text-xs-left">{{ props.item.Tipi }}</td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
          </v-alert>
        </v-data-table>
      </v-card>

      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Hesap Kodu',
            value: 'Kod'
          },
          {
            text: 'Hesap Adı ',
            value: 'Adi'
          },
           {
            text: 'Tipi ',
            value: 'Tipi'
          }



        ],
        loading: false,
        progress:false,
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        addgib:false,

  hesap:{
    Kod:'',
    Adi:'',
    Tipi:'',
  },
        state: [],
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        dictionary: {
          custom: {
            gibseri: {
              required: () => 'Bu alan boş bırakılamaz',
              max: () => 'İki karakterden fazla olamaz'
            },
            sirketadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
            this.addgib=false

        this.k = false
        this.m = true
        this.$validator.reset()

        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Hesap Gurubu  Güncelle'
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          CompanyCode: credentials.SirketKodu,
          Code:v
        }
        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesap = response.body
        })
      },
      deletehesap: deletehesap,
      hesapekle: hesapekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
  }

  function Kaydet() {
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$validator.validateAll().then((result) => {
      if (result) {
        var params = {
      CompanyCode: credentials.SirketKodu,
      Code: this.hesap.Kod,
      Name: this.hesap.Adi,
      Type: this.hesap.Tipi
        }

        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.dialog = false
        var params1 = {
          CompanyCode: credentials.SirketKodu
        }
          this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable.'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable.'
                this.snackbar = true
              }
            })
          })
}

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          }
        })
      }





  function hesapekle() {

    this.dialog = true
    this.hesap = {}
    this.addgib=true
    this.dialog_baslik = 'Hesap Gurubu Ekle'
    this.m = false
    this.k = true
    this.$validator.reset()

  }

  function beforeMount() {
    this.progress=true
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));

var params = {
  CompanyCode: credentials.SirketKodu
}

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress=false
    }, (response) => {
      if (response.status === 0) {
              this.progress=false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
              this.progress=false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function deletehesap() {

    this.addgib=false
    if (window.confirm('Hesap Gurubu\'nu silmek istediğinizden eminmisiniz?')) {
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params = {
        CompanyCode:  credentials.SirketKodu,
        Code: this.hesap.Kod,
          Name: this.hesap.Adi,
      Type: this.hesap.Tipi

      }
      this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true


              var params1 = {
                CompanyCode:credentials.SirketKodu
              }
          this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
               this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
             this.text1 = 'Service Unavailable'
              this.snackbar = true
        } else {
             this.text1 = 'Service Unavailable'
              this.snackbar = true
        }
      })
    }
  }

  function guncelle() {

    this.addgib=false
    this.$validator.validateAll().then((result) => {
      if (result) {
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
      CompanyCode: credentials.SirketKodu,
      Code: this.hesap.Kod,
      Name: this.hesap.Adi,
      Type: this.hesap.Tipi
}

        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
              var credentials = JSON.parse(window.localStorage.getItem('credentials'));

              var params1 = {
                CompanyCode:credentials.SirketKodu
              }
            this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>